import type { AlDailyWindowDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';

// ============================================================================
// AL daily-report window (GitHub #81) — GET /api/finance/compliance/al-daily-window.
// Powers the standing "you're in the daily-report window" banner in the Close hub's
// alert band. `isInWindow` drives visibility; the bounds + electionDate name the
// window; ruleText is the treasurer-facing explanation (always present).
// ============================================================================

export const useAlDailyWindow = defineQuery({
  key: () => ['finance', 'compliance', 'al-daily-window'],
  reads: 'GET /api/finance/compliance/al-daily-window',
  staleTime: 60_000,
  fetch: (_: undefined, { campaignId }): Promise<AlDailyWindowDto> =>
    apiJson<AlDailyWindowDto>('/api/finance/compliance/al-daily-window', {
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch the daily-report window',
    }),
});
